import { render, staticRenderFns } from "./ContactsMenu.vue?vue&type=template&id=253ecd69&scoped=true"
import script from "./ContactsMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactsMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContactsMenu.vue?vue&type=style&index=0&id=253ecd69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ecd69",
  null
  
)

export default component.exports